module.exports = __webpack_public_path__ + "static/media/alert-summary.ec745948.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reportcentre/alert-summary.jpg
// module id = 2936
// module chunks = 0